<template>
    <div class="cz2__checkout__atc">
        <btn
            primary
            onDark
            :disabled="hasError"
            @click="checkForProtector"
            id="cz2__checkout__cta"
            class="cz2__full-width cz2__full-height cz2__stationary-text-transform"
        >
            <span v-if="isKiosk">
                {{ $t('PRINT_TICKET') }}
            </span>
            <span v-else-if="editingFromCart">
                {{ $t('ACTION_UPDATE_CART') }}
            </span>
            <span v-else>
                {{ $t('ACTION_CONFIRM_BUILD') }}
            </span>
        </btn>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";
    @import "../style/shared.scss";

    #cz2.cz2 {
        .cz2__steps-options__checkout {
            .cz2__checkout__atc {
                display: flex;
                flex-direction: column;
                gap: 12px;

                .cz2__btn {
                    pointer-events: auto;
                }

                @include respond-above(md) {
                    margin-top: var(--layout-gap);
                    flex-direction: row;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__checkout__atc {
            width: 100%;
            .cz2__btn {
                height: 64px !important;
                font-size: 22px;
                width: 100%;
            }
        }
    }
</style>

<script>
    import Btn from './ui/Btn.vue';

    export default {
        components: {
            Btn,
        },

        computed: {
            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            viewController() {
                return this.$store.state.customizer.viewController;
            },

            hasError() {
                return this.$store.state.customizer.alertGroups.length > 0;
            },

            editingFromCart() {
                return this.$store.state.customizer.options.recipeFrom === 'cart';
            },

            protector() {
                return this.$store.getters.protector;
            },

            availableProtector() {
                return this.$store.getters.availableProtector;
            },

            configurationVersion() {
                return this.$store.state.customizer.configurationVersion;
            },

            recipeOverride() {
                return this.$store.state.customizer.recipeOverride;
            },
        },

        methods: {
            checkForProtector() {
                if (this.protector || this.availableProtector == null) {
                    this.addToCart();
                } else {
                    this.$store.dispatch('showProtectorUpsell', true);
                }
            },

            addToCart() {
                if (this.isKiosk) {
                    this.$store.dispatch('printFlow');
                } else {
                    this.$store.dispatch('trackAddToCart', {
                        controller: this.viewController,
                    });

                    this.$store.dispatch('saveRecipe', {
                        type: 'cart',
                    });
                }
            },

            openApplePay() {
                console.log('apple pay');
            },
        },
    };
</script>
